<template>
  <div class="ui grid">
    <div class="row">
      <h1 class="ui huge header">Welcome</h1>
    </div>
    <div class="ui divider"></div>
    <div class="row">
      <p v-if="user">
        Welcome {{ user.profile.name }}! Please select one of the following
        options below to get started
      </p>
    </div>
    <div class="row">
      <div class="ui divided items">
        <div v-if="user.profile.role === 'Administrator'" class="item">
          <div class="image">
            <router-link to="/school/select"><i class="massive building icon"></i></router-link>
          </div>
          <div class="content">
            <div class="header">Manage schools</div>
            <div class="meta">
              <span>Select to manage the schools</span>
            </div>
            <div class="description">
              <!-- eslint-disable-next-line max-len -->
              With this option you can view the list of schools and their
              licence status.
            </div>
          </div>
        </div>
        <div v-if="user.profile.role === 'Administrator'" class="item">
          <div class="image">
            <router-link to="/licenses"><i class="massive file pdf icon"></i></router-link>
          </div>
          <div class="content">
            <div class="header">View licenses</div>
            <div class="meta">
              <span>Select to view the licenses</span>
            </div>
            <div class="description">
              <!-- eslint-disable-next-line max-len -->
              With this option you can view the list of expiring and expired licenses
            </div>
          </div>
        </div>
        <div v-if="user.profile.role === 'Administrator'" class="item">
          <div class="image">
            <router-link to="/invoices"><i class="massive file alternate icon"></i></router-link>
          </div>
          <div class="content">
            <div class="header">View invoices</div>
            <div class="meta">
              <span>Select to view the invoices</span>
            </div>
            <div class="description">
              <!-- eslint-disable-next-line max-len -->
              With this option you can view the list of paid and unpad invoices
            </div>
          </div>
        </div>
        <div v-if="user.profile.role === 'Administrator'" class="item">
          <div class="image">
            <router-link to="/teacher/select"><i class="massive users icon"></i></router-link>
          </div>
          <div class="content">
            <div class="header">View last active teachers</div>
            <div class="meta">
              <span>Select to view the list of last active teachers</span>
            </div>
            <div class="description">
              <!-- eslint-disable-next-line max-len -->
              With this option you can view the list of teachers that have signed in lately
            </div>
          </div>
        </div>
        <div v-if="user.profile.role === 'Administrator'" class="item">
          <div class="image">
            <router-link to="/report/select"><i class="massive file excel icon"></i></router-link>
          </div>
          <div class="content">
            <div class="header">Reports</div>
            <div class="meta">
              <span>Select to view the reports</span>
            </div>
            <div class="description">
              <!-- eslint-disable-next-line max-len -->
              With this option you can view the various reports that are available
            </div>
          </div>
        </div>
        <div v-if="user.profile.role === 'Administrator'" class="item">
          <div class="image">
            <router-link to="/website"><i class="massive globe icon"></i></router-link>
          </div>
          <div class="content">
            <div class="header">Website</div>
            <div class="meta">
              <span>Manage the website</span>
            </div>
            <div class="description">
              <!-- eslint-disable-next-line max-len -->
              With this option you can manage the website content and settings
            </div>
          </div>
        </div>
        <div v-if="user.profile.role === 'TeacherAdministrator'" class="item">
          <div class="image">
            <router-link to="/school/details"><i class="massive building icon"></i></router-link>
          </div>
          <div class="content">
            <div class="header">Manage school</div>
            <div class="meta">
              <span>Select to manage your school</span>
            </div>
            <div class="description">
              <!-- eslint-disable-next-line max-len -->
              With this option you can manage your school's teachers.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Home',
  components: {},
  computed: mapGetters({
    user: 'user',
    usersSchool: 'usersSchool',
  }),
  data() {
    return {};
  },
  methods: {},
  created() {
    this.$store.dispatch('hideLoader');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Home.vue